import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Button from "../../components/Button/Button";
import FormActions from "../../components/FormActions/FormActions";
import TalentInput from "../../components/TalentInput/TalentInput";
import { withFirebase } from "../../components/Firebase/Firebase";
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";

// Scaffold object with fields for a new team member being added
const newTalent = {
	expanded: true,
	firstName: "",
	lastName: "",
	emailAddress: "",
	releaseForm: "",
	mobileNumber: "",
	age: ""
};

class Stage4 extends Component {
	state = {
		talent: {}
	};
	
	componentDidMount() {
		// Look for any existing data
		if (
			this.props.entries[this.props.id] &&
			this.props.entries[this.props.id].talent
		) {
			const entryData = this.props.entries[this.props.id];
			const talent = {};
			// Transform the data slightly to add the expanded prop
			Object.keys(entryData.talent).forEach((talentId, ix) => {
				talent[talentId] = {
					...newTalent,
					...entryData.talent[talentId],
					expanded: ix === 0
				};
			});
			this.setState({
				talent
			});
		}
	}
	
	continue = async () => {
		await this.props.methods.updateEntryStage(this.props.id, 5);
	};
	
	previous = async () => {
		await this.props.methods.updateEntryStage(this.props.id, 3);
	};
	
	addTalent = async () => {
		const newId = await this.props.methods.addTalentToEntry(this.props.id);
		// Once we've got confirmation from firebase, update local state to match
		
		// Contract all other team members
		const talent = {};
		
		// Transform the data slightly to add the expanded prop
		Object.keys(this.state.talent).forEach((talentId, ix) => {
			talent[talentId] = {
				...this.state.talent[talentId],
				expanded: false
			};
		});
		
		this.setState({
			talent: {
				...talent,
				[newId]: { ...newTalent }
			}
		});
	};
	
	removeTalent = async id => {
		await this.props.methods.removeTalentFromEntry(this.props.id, id);
		const { talent } = this.state;
		delete talent[id];
		this.setState({
			talent
		});
	};
	
	toggleTalent = id => {
		const { talent } = this.state;
		Object.keys(talent).forEach(talentId => {
			talent[talentId].expanded = talentId === id;
		});
		this.setState({
			talent
		});
	};
	
	handleTalentInputEvent = (e, key, id) => {
		const { talent } = this.state;
		talent[id][key] = e.target.value;
		this.setState({
			talent
		});
	};
	
	handleTalentUpdate = (e, id) => {
		this.props.methods.updateTalent(this.props.id, id, this.state.talent[id]);
	};
	// This is a custom handler, it will update state with the new filename and pass the update back to firebase
	handleTalentFileUpload = (filename, talentId, key) => {
		const { talent } = this.state;
		talent[talentId][key] = filename;
		this.setState(
			{
				talent
			},
			() => {
				this.handleTalentUpdate(null, talentId);
			}
		);
	};
	
	isValid = () => {
		let isValid = true;
		Object.entries(this.state.talent).forEach(([id, talent]) => {
			let isMemberValid = true;
			if (!talent.firstName) {
				isMemberValid = false;
			}
			if (!talent.lastName) {
				isMemberValid = false;
			}
			if (!talent.emailAddress) {
				isMemberValid = false;
			}
			if (!talent.releaseForm) {
				isMemberValid = false;
			}
			if (!talent.mobileNumber) {
				isMemberValid = false;
			}
			if (!talent.age) {
				isMemberValid = false;
			}
			// If validation has changed, update the member
			if(talent.isValid !== isMemberValid) {
				talent.isValid = isMemberValid;
				this.setState({talent : {
					...this.state.talent,
					[id]: talent
				}})
			}
			if(!isMemberValid) isValid = false;
		});
		return isValid;
	};
	
	render() {

		if(!this.props.terms) return null;

		return (
			<div>


			<div className="step-header">
				Step 3 of 5
			</div>
			
			<RichText content={this.props.terms.stage_4} />
			{Object.keys(this.state.talent).map(talentId => {
				const talent = this.state.talent[talentId];
				return (
					<TalentInput
					{...talent}
					key={talentId}
					entryId={this.props.id}
					talentId={talentId}
					removeSelf={() => this.removeTalent(talentId)}
					toggleSelf={() => this.toggleTalent(talentId)}
					handleUpdate={e => {
						this.handleTalentUpdate(e, talentId);
					}}
					handleInputEvent={(e, key) =>
						this.handleTalentInputEvent(e, key, talentId)
					}
					handleFileUpload={(filename, key) =>
						this.handleTalentFileUpload(filename, talentId, key)
					}
					/>
				);
			})}
			<FormActions
			left={
				<div>
				<Button onClick={this.previous}>Back</Button>
				</div>
			}
			right={
				<div>
				<Button onClick={this.addTalent}>Add Person</Button>
				<Button
				onClick={this.continue}
				type="primary"
				disabled={!this.isValid()}
				>
				Finished
				</Button>
				</div>
			}
			/>
			</div>
		);
	}
}

export default withRouter(withPrismic(withFirebase(Stage4)));



// WEBPACK FOOTER //
// ./src/pages/CompetitionEnter/Stage4.js